<plat-sidebar></plat-sidebar>

<div class="app-wrapper" *ngIf="showMainFrame$ | async">
	<router-loader></router-loader>
	<router-outlet></router-outlet>
</div>

<div class="neo" *ngIf="(isLoggedIn$ | async)?.loggedIn" [class.disabled]="!(showNeoFrame$ | async)">
	<neo-frame></neo-frame>
</div>

<div class="argus" *ngIf="(isLoggedIn$ | async)?.loggedIn && argusHasBeenOpened" [class.disabled]="!(showARGUSFrame$ | async)">
	<argus-frame></argus-frame>
</div>
<router-outlet name="argus-outlet"></router-outlet>

<!-- deletes itself after initial use -->
<load-additional-translations></load-additional-translations>

<notifier-container></notifier-container>



// WEBPACK FOOTER //
// ./src/app/app.component.html